var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteBinIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.168 5.00002H18.3346V6.66669H16.668V17.5C16.668 17.9603 16.2949 18.3334 15.8346 18.3334H4.16797C3.70774 18.3334 3.33464 17.9603 3.33464 17.5V6.66669H1.66797V5.00002H5.83464V2.50002C5.83464 2.03979 6.20774 1.66669 6.66797 1.66669H13.3346C13.7949 1.66669 14.168 2.03979 14.168 2.50002V5.00002ZM15.0013 6.66669H5.0013V16.6667H15.0013V6.66669ZM7.5013 9.16669H9.16797V14.1667H7.5013V9.16669ZM10.8346 9.16669H12.5013V14.1667H10.8346V9.16669ZM7.5013 3.33335V5.00002H12.5013V3.33335H7.5013Z",
    fill: "#3F4753"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBinIcon);
export default __webpack_public_path__ + "static/media/delete-bin-icon.06edc55ce584d90c95acee99a663e708.svg";
export { ForwardRef as ReactComponent };